import { memo, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from 'components/v3';
import RetryIcon from 'svg/retry.svg';
import { fetchRetriedQuestion, fetchAnswerOfInterpretation } from 'store/modules/chat-messages';

import { trackEvent } from 'utils/eventTracking';
import styles from '../message.scss';

const RetryButton = ({
  questionId,
  localQuestionId,
  isLlmParserEnabled,
  isSystemZeroEnabled,
  alternativeInterpretations,
  answerId
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleRetryButtonClick = useCallback(() => {
    trackEvent('Retry Button Clicked', { questionId });
    if (isLlmParserEnabled || isSystemZeroEnabled) {
      // use the retry endpoint to try again if any of the LLM-based features are available
      dispatch(fetchRetriedQuestion(questionId, localQuestionId, t));
    } else if (alternativeInterpretations?.length > 0) {
      dispatch(fetchAnswerOfInterpretation(alternativeInterpretations[0].interpretationId, answerId, ''));
    } else {
      // this shouldn't happen as the retry button is hidden in this case
      console.error('Cannot perform retry');
    }
  }, [dispatch, localQuestionId]);

  return (
    <InfoTooltip text={t('tooltip.try-answering-again')}>
      <div onClick={handleRetryButtonClick} className={styles.iconButtonContainer} data-test="tryAgain">
        <RetryIcon className={clsx(styles.iconButtonIcon)} />
        <span className={styles.iconButtonLabel}>{t('retry')}</span>
      </div>
    </InfoTooltip>
  );
};

export default memo(RetryButton);
